import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.css'
import 'draft-js/dist/Draft.css'
import { Editor, EditorState, RichUtils } from 'draft-js'
import boldIconSrc from './bold.svg'
import italicIconSrc from './italic.svg'
//import underlineIconSrc from './underline.svg'
import cx from 'classnames'
import debounce from 'lodash/debounce'
import { updateAppLongDescription } from 'api/developerApi'
import { stateToMarkdown } from 'draft-js-export-markdown'
import { stateFromMarkdown } from 'draft-js-import-markdown'

const MAX_CHARS = 300
const UPDATE_DELAY_IN_MS = 300


class AppDetailedView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showErrorNotification: PropTypes.func.isRequired,
    app: PropTypes.shape({
      longDescription: PropTypes.string,
    })
  }

  constructor(props) {
    super(props)
    this.state = {
      editorState: this.resolveEditorState(props.app.longDescription),
      isEditorFocused: false
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      editorState: this.resolveEditorState(props.app.longDescription)
    })
  }

  resolveEditorState = (longDescription) => {
    return longDescription
      ? EditorState.createWithContent(stateFromMarkdown(longDescription))
      : EditorState.createEmpty()
  }

  changeEditorState = (editorState) => {
    const longDescription = stateToMarkdown(editorState.getCurrentContent())
    const onStateSet = () => this.updateLongDescriptionDebounced(longDescription)

    this.setState({ editorState }, onStateSet)
  }

  hasReachedMaxLength = (chars) => {
    const { editorState } = this.state
    const totalLength = editorState.getCurrentContent().getPlainText().length + chars.length
    return totalLength > MAX_CHARS
  }

  handleBeforeInput = (chars) => {
    return this.hasReachedMaxLength(chars)
  }

  onBoldClick = () => {
    const { editorState } = this.state
    this.changeEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'))
  }

  onItalicClick = () => {
    const { editorState } = this.state
    this.changeEditorState(RichUtils.toggleInlineStyle(editorState, 'ITALIC'))
  }

  onUnderlineClick = () => {
    const { editorState } = this.state
    this.changeEditorState(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'))
  }

  captureEditorRef = (ref) => {
    this.editor = ref
  }

  focusEditorInput = () => {
    this.setState({ isEditorFocused: true })
    setTimeout(() => this.editor && this.editor.focus(), 0)
  }

  blurEditorInput = () => {
    this.setState({ isEditorFocused: false })
  }

  updateLongDescription = (longDescription) => {
    const { appId } = this.props
    const onError = (error) => this.props.showErrorNotification('We couldn’t update the long description. Please try again.')

    updateAppLongDescription({ longDescription, appId })
      .catch(onError)
  }

  updateLongDescriptionDebounced = debounce(this.updateLongDescription, UPDATE_DELAY_IN_MS)

  render() {
    const { editorState, isEditorFocused } = this.state

    return (
      <div className="app-detailed-view">
        <span className="app-detailed-view-title">
          Detailed View
        </span>

        <p className="app-detailed-view-description">
          For rich descriptions, we recommend creating your description in the editor of your choice and then pasting in the text box below.<br/>
        </p>
        <p className="app-detailed-view-description">
          This information will show on your app page in Drift. Use this space to describe the benefits of your app and how to use it.
        </p>

        <div
          className="app-details-editor"
          onClick={this.focusEditorInput}
          onBlur={this.blurEditorInput}>

          <span className="app-details-editor-title">
            App Details
          </span>
          <div className={cx('app-details-editor-body', {
            'app-details-editor-body-focused': isEditorFocused
          })}>
            <Editor
              id="ref-app-details-editor"
              editorState={editorState}
              onChange={this.changeEditorState}
              handleBeforeInput={this.handleBeforeInput}
              placeholder="Add a long description about how to use your app and how it will benefit its users. This description will show up on your App Detail page..."
              ref={this.captureEditorRef}
            />
            <div className="app-details-editor-buttons">
              <img
                src={boldIconSrc}
                onClick={this.onBoldClick}
                alt="bold"
              />
              <img
                src={italicIconSrc}
                onClick={this.onItalicClick}
                alt="italic"
              />
              {/*<img
                src={underlineIconSrc}
                onClick={this.onUnderlineClick}
                alt="underline"
              />*/}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppDetailedView
